/*
Sort List of generated invitation links by date in desc order (new dates first)
*/
export function sortInviteLinksListByExpiryDateDescending(list: { name: string; total: number; used: number; expiryDate: Date; pageLink: string }[]): { name: string; total: number; used: number; expiryDate: Date; pageLink: string }[] {
  return list.sort((a, b) => b.expiryDate.getTime() - a.expiryDate.getTime());
}
